import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedMainConfigThirdProvider from './viewRelatedMainConfigThirdProvider';

export default {
  title: 'Third Party Providers Available',
  attributeName: 'thirdPartyProvider',
  fields: [
    {
      attributeName: 'thirdPartyProviders',
      label: 'Available',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      configFile: viewRelatedMainConfigThirdProvider,
      default: [],
      helpText:'Displays only external authentication providers that are blocked or have assigned content, matching the current client visibility.',
      enabledWhen: { "field": "config", "notValues": ['(Empty)', '(All)'] },
    },
  ],
};
